import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import CartaServicoService from '../../../../../services/cartaServico-auth';
import SecretariaService from '../../../../../services/secretaria';
import Carta from './carta';


const ListarCartas = () => {

    const [cartas, setCartas] = useState([]);
    const [editar, setEditar] = useState("");
    const [ver, setVer] = useState("");
    const [vazio, setVazio] = useState(false);
    const [carta, setCarta] = useState("");
    const [secretarias, setSecretarias] = useState([]);

    const montaSec = async () => {
        const secs = await SecretariaService.listar()
        setSecretarias(secs.data)
    }

    async function fetchCartas() {
        await montaSec()
        const response = await CartaServicoService.listar();
        if (response.data.length >= 1) {
            setCartas(response.data)
            setVazio(false)
        } else {
            setCartas([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setCarta(id);
        setEditar(true)
    }

    const handleVer = (id) => {
        setCarta(id);
        setVer(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a Carta de Serviço?')) {
            await CartaServicoService.deletar(id)
            alert("Carta de Serviço deletada com sucesso!")
            fetchCartas();
        }
    }

    useEffect(() => {
        fetchCartas();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/institucional/cartaservico/editar/${carta}`} />
        )
    } else if (ver) {
        return (
        <Navigate to={`/restrito/institucional/cartaservico/carta/${carta}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setCartas={setCartas}
                        setVazio={setVazio}
                        fetchCartas={fetchCartas}
                        secretarias={secretarias}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1}>
                            {cartas.map((carta, index) =>
                                <Carta
                                    fetchCartas={fetchCartas}
                                    carta={carta}
                                    key={index}
                                    ver={handleVer}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarCartas;